import React from "react";

const SalesmanIcon = (props) => {
  let height = props?.height ? props?.height : 20;
  let width = props?.width ? props?.width : 20;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 24 24"
    >
      <g transform="matrix(1.0999999999999996,0,0,1.0999999999999996,-1.1999999999999904,-1.1999999999999904)">
        {/* Person with briefcase and chart */}
        <path
          d="M12 2a3 3 0 1 0 3 3 3 3 0 0 0-3-3z"
          fill="currentColor"
        />
        <path
          d="M12 8c-2.5 0-4.5 2-4.5 4.5V16h9v-3.5c0-2.5-2-4.5-4.5-4.5z"
          fill="currentColor"
          opacity="0.9"
        />
        <rect x="8" y="16" width="8" height="3" rx="0.5" fill="currentColor" opacity="0.7" />
        <path
          d="M16 12l3-3 3 3"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M19 9v7" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path
          d="M2 19h20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          opacity="0.6"
        />
      </g>
    </svg>
  );
};

export default SalesmanIcon;